var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorLayout',[_c('p',[_vm._v("パスワードの有効期限が切れています。")]),_c('p',[_vm._v("新しいダミーIDとパスワードを発行して、再度ログインしてください。")])])
}
var staticRenderFns = []

export { render, staticRenderFns }